define(['jquery',
        'core/urls'],
    function($, urls) {
        var _chargebeeInstance;

        function createChargebeeSingleton() {
            // make sure the Chargebee.js library has been loaded successfully
            if (typeof Chargebee === 'undefined') {
                $('#alert-subscription-danger').slideDown();
                // exit function if chargebee.js is not defined
                return;
            }

            // initialize Chargebee JS
            Chargebee.init({
                site: globals.settings.CHARGEBEE_SITE,
                domain: globals.settings.CHARGEBEE_DOMAIN_URL
            });
            _chargebeeInstance = Chargebee.getInstance();
        }

        function getChargebeeInstance() {
            if (!_chargebeeInstance) {
                createChargebeeSingleton();
            }
            return _chargebeeInstance;
        }

        // private functions
        function getCheckoutHostedPage(planId) {
            return $.ajax({
                type: 'POST',
                url: urls['account:new-hosted-page-checkout'](),
                dataType: 'json',
                data: {
                    'plan_id': planId
                }
            });
        }

        function openCheckoutModal(planId, successCallback, failureCallback, cancelCallback) {
            getChargebeeInstance().openCheckout({
                hostedPage: function() {
                    return getCheckoutHostedPage(planId)
                },
                success: function(hostedPageId) {
                    $.ajax({
                        type: 'POST',
                        url: urls['account:finish-hosted-page-checkout'](),
                        data: {
                            'hosted_page_id': hostedPageId
                        },
                        global: false,
                        success: function () {
                            getChargebeeInstance().closeAll();
                            successCallback();
                        },
                        error: failureCallback
                    });
                },
                close: cancelCallback
            });
        }

        function openPortalModal(closeCallback) {
            getChargebeeInstance().setPortalSession(function() {
                return $.ajax({
                    url: urls['account:new-portal-session'](),
                    method: 'POST'
                });
            });

            var cbPortal = getChargebeeInstance().createChargebeePortal();
            cbPortal.open({
                close: function() {
                    if (closeCallback !== undefined)
                        closeCallback();
                }
            });
        }

        // public functions
        return {
            openCheckoutModal: openCheckoutModal,
            openPortalModal: openPortalModal
        }
    }
);
